import { z } from "zod/v4";

import { BaseVoucherSchema } from "@common/schemas/VoucherSchema";

const VoucherSchema = BaseVoucherSchema.extend({
  giftMessage: z.string().nullable(),
  qrCode: z.string(),
  code: z.string(),
});
export const VoucherLookupResponseSchema = z.object({
  voucherLookup: z.object({
    voucher: VoucherSchema,
    voucherToken: z.string(),
    voucherTokenExpiresAt: z.number(),
  }),
});

export const VoucherAssignmentSchema = z.object({
  amountInCents: z.number().int().min(0),
  uuid: z.string(),
  voucherUuid: z.string(),
  voucher: VoucherSchema,
  cartUuid: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export const VoucherAssignmentsSchema = z.array(VoucherAssignmentSchema);
export type VoucherAssignment = z.infer<typeof VoucherAssignmentSchema>;
export type Voucher = z.infer<typeof VoucherSchema>;
export type VoucherLookupResponse = z.infer<typeof VoucherLookupResponseSchema>;
